import React from "react";
import { IconButton } from "@mui/material";
import { ButtonIconProps } from "./types";
import "./styles.scss";

const classNameBase = "scd-button-icon";

export default function CustomIconButton(
  props: ButtonIconProps,
): React.JSX.Element {
  const { disabled, onClick, icon, title, ...other } = props;

  const buttonClassName = disabled
    ? `${classNameBase}-disabled`
    : `${classNameBase}`;

  return (
    <IconButton
      className={buttonClassName}
      disabled={disabled}
      onClick={onClick}
      title={title}
      {...other}
    >
      <i className={`icon-scd-${icon}`} />
    </IconButton>
  );
}
